var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendApplicationIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5387:32757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.78732 10.9553C6.78732 11.4201 6.41005 11.7974 5.94521 11.7974H1.73468C1.26984 11.7974 0.892578 11.4201 0.892578 10.9553C0.892578 10.4904 1.26984 10.1132 1.73468 10.1132H5.94521C6.41005 10.1132 6.78732 10.4904 6.78732 10.9553Z",
    fill: "#3913D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1031 15.1657C5.1031 15.6305 4.72584 16.0078 4.261 16.0078H1.73468C1.26984 16.0078 0.892578 15.6305 0.892578 15.1657C0.892578 14.7009 1.26984 14.3236 1.73468 14.3236H4.261C4.72584 14.3236 5.1031 14.7009 5.1031 15.1657Z",
    fill: "#3913D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41889 19.3762C3.41889 19.8418 3.04163 20.2183 2.57679 20.2183H1.73468C1.26984 20.2183 0.892578 19.8418 0.892578 19.3762C0.892578 18.9105 1.26984 18.534 1.73468 18.534H2.57679C3.04163 18.534 3.41889 18.9105 3.41889 19.3762Z",
    fill: "#3913D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0914 21.9026C27.5642 23.7628 25.6282 25.271 23.768 25.271H6.92593C5.06572 25.271 3.9853 23.7628 4.51246 21.9026L7.37393 11.7973C7.90109 9.9371 9.83625 8.42889 11.6965 8.42889H28.5386C30.3988 8.42889 31.48 9.9371 30.9529 11.7973L28.0914 21.9026Z",
    fill: "#3913D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4922 15.7013L4.58525 23.5438C4.55662 23.5674 4.53978 23.5968 4.51367 23.6204C4.66441 24.1013 4.94988 24.4987 5.34904 24.7859C5.37851 24.7665 5.41051 24.7581 5.43915 24.7362L16.3461 16.892C16.768 16.5627 16.9187 16.0314 16.6838 15.7013C16.4471 15.372 15.9149 15.372 15.4922 15.7013Z",
    fill: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1199 23.6204C27.1073 23.5968 27.1064 23.5674 27.0913 23.5446L20.6289 15.7013C20.3923 15.372 19.8601 15.372 19.4365 15.7013C19.0146 16.0305 18.8639 16.5627 19.0997 16.892L25.5628 24.7354C25.5788 24.7581 25.6058 24.7665 25.6243 24.7859C26.186 24.4996 26.6972 24.1004 27.1199 23.6204Z",
    fill: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.956 11.7974C31.4832 9.93716 30.4019 8.42895 28.5417 8.42895H11.6996C9.83853 8.42895 7.90337 9.93716 7.37706 11.7974L7.35938 11.8597L14.775 18.9763C16.1484 20.3102 17.964 20.2184 19.596 19.2887L30.7337 12.5822L30.956 11.7974Z",
    fill: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5397 8.42902H11.6976C10.3688 8.42902 9.01217 9.2046 8.14648 10.3221L15.9082 17.7275C16.5389 18.333 17.9579 18.3414 18.9869 17.7275L31.024 10.344C30.8 9.2147 29.877 8.42902 28.5397 8.42902Z",
    fill: "#3913D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5387:32757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.0507812 0.0078125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendApplicationIcn);
export default __webpack_public_path__ + "static/media/Send Application Icn.d30ef4be.svg";
export { ForwardRef as ReactComponent };